import React from "react";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import moment from "moment";

import {
  markUpDownContextAction,
  useMarkUpContext
} from "./FeaturesSetupMarkUpContext";
import markUpItemInterface from "./markUpItemInterface";
import FeaturesSetupMarkPopupListItemDeleteButton from "./FeaturesSetupMarkPopupListItemDeleteButton";
import {getRevertedPriceAndCost} from "./markUpFunctions";

const FeaturesSetupMarkPopupListItem = (props) => {

  const {markUpListItem, markUpListItemIndex, featuresList} = props;
  const {type, value, priceType, created, updated, applyTo} = markUpListItem;
  const {markUpDownContextState, markUpDownContextDispatch} = useMarkUpContext();
  const {activeMarkUpItemIndex} = markUpDownContextState;

  const featuresAssigned = featuresList.filter((feature)  => {
    if (!feature.markUpLogic) {
      return false
    }
    const markUpLogic = JSON.parse(feature.markUpLogic);
    return Array.isArray(markUpLogic) && markUpLogic.some(markUpItem => markUpItem.id === markUpListItem.id)
  });

  // if (totalFeaturesLength && (upDownCheckboxValue !== type) || (currencyPercentageCheckboxValue !== priceType)) {
  //   return null
  // }

  const markUpListItemClick = (event) => {
    const excludedClassNames = ["ui-mark-list__item-icon-button"];
    if (excludedClassNames.some(className => event.target.classList.contains(className) || event.target.closest("."+className))) {
      return false
    }
    markUpDownContextDispatch(markUpDownContextAction({
      activeMarkUpItemIndex: markUpListItemIndex,
      upDownCheckboxValue: type,
      currencyPercentageCheckboxValue: priceType,
      markUpDownInputValue: value,
      applyToValue: applyTo,
    }))
  };

  console.log("featuresAssigned", featuresAssigned);

  return (
    <li className={"ui-mark-list__item" + (markUpListItemIndex === activeMarkUpItemIndex ? " ui-mark-list__item--selected" : "")}
        onClick={markUpListItemClick}>
      <div className="ui-mark-list__item-cell">
        <span className="stone-filter-price-adj-lir__title">
          {priceType === "currency" ? "$" : null}
          {value}
          {priceType === "currency" ? " " : null}
          {priceType === "percentage" ? "% " : null}
          <FormattedMessage id={"features.setup.markUpDownPopup.checkbox.mark." + type}/>
          {" | "}
          <FormattedMessage id={"features.setup.markUpDownPopup.applyTo." + getRevertedPriceAndCost(applyTo)}/>
        </span>
        <p className="stone-filter-price-adj-lir__date">
          {moment.unix(created).format("MMMM Do YYYY HH:mm")}
          {updated ? " | Updated: " + moment.unix(updated).from(moment.unix(created)) : null}
        </p>
      </div>
      <div className="ui-mark-list__item-cell ui-mark-list__item-cell--count ui-legend">
        <span className="ui-mark-list__item-count">{featuresAssigned.length}</span>
        <ul className="ui-legend__info secondary fix-ul">
          {featuresAssigned.map((feature, featureIndex) => {
            return (
              <li key={feature.name + featureIndex}>{feature.name}</li>
            )
          })}
        </ul>
      </div>
      <div className="ui-mark-list__item-cell">
        <FeaturesSetupMarkPopupListItemDeleteButton markUpListItem={markUpListItem} featuresAssigned={featuresAssigned}/>
      </div>
    </li>
  )
};

FeaturesSetupMarkPopupListItem.propTypes = {
  markUpListItem: PropTypes.shape(markUpItemInterface),
  markUpListItemIndex: PropTypes.number,
  featuresList: PropTypes.array,
}

export default FeaturesSetupMarkPopupListItem
